export const isInventoryVisible = (
  index: number,
  limit: number,
  hasBulk: boolean,
) => {
  if (limit === 0) {
    return true;
  }

  const actualLimit = limit - (hasBulk ? 1 : 0);
  return index < actualLimit;
};
